// Lets the main nav tell the layout that a flyout module was clicked.
//
// The panel opens on its own whenever the URL is inside a flyout module, so
// deep links and refreshes need no state at all. The one thing the URL cannot
// tell us is "the user pressed Back to see the main menu again", which is why
// there is a context here rather than a plain pathname check.

import { createContext, useContext } from 'react';

const NavFlyoutContext = createContext({
  // Called when a flyout entry is clicked in the main nav. Re-opens the panel
  // even when the click does not change the URL, which happens if you are
  // already sitting on the module root with the menu showing.
  onEnterFlyout: () => {},
  // The module whose panel is currently up, or null.
  activeFlyoutPath: null,
});

export const NavFlyoutProvider = NavFlyoutContext.Provider;

export default function useNavFlyout() {
  return useContext(NavFlyoutContext);
}
